import { IConversionType } from "@/containers/Converter/types";

const FREE_CONVERSION_TYPES: IConversionType[] = [
  // Add conversion types that are free here.
];

export const isFreeConversion = (conversionType: IConversionType) => {
  return FREE_CONVERSION_TYPES.includes(conversionType);
};
